/* projects/shared/src/lib/components/file-content-editor/file-content-editor.component.scss */
:host {
  display: block;
  width: 100%;
}
.file-content-editor {
  width: 100%;
}
.file-content-editor__header {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 12px;
}
.file-content-editor__header h3 {
  margin: 0 0 4px;
}
.file-content-editor__header span {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}
.file-content-editor__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}
.file-content-editor__error {
  color: #f44336;
  font-size: 12px;
  margin: 4px 0 10px;
}
.file-content-editor__monaco {
  display: block;
  height: 36rem;
  max-height: 70vh;
  min-height: 24rem;
  width: 100%;
}
.file-content-editor__preview {
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  min-height: 36rem;
  overflow: hidden;
}
.file-content-editor__preview-title {
  background: #f5f5f5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 12px;
  font-weight: 500;
  padding: 8px 12px;
}
.file-content-editor__preview iframe {
  border: 0;
  height: calc(36rem - 37px);
  width: 100%;
}
@media (max-width: 959px) {
  .file-content-editor__header {
    flex-direction: column;
  }
  .file-content-editor__actions {
    justify-content: flex-start;
  }
}
/*# sourceMappingURL=file-content-editor.component.css.map */
